import { render, staticRenderFns } from "./header-access-espace.vue?vue&type=template&id=572e0326&scoped=true"
import script from "./header-access-espace.vue?vue&type=script&lang=js"
export * from "./header-access-espace.vue?vue&type=script&lang=js"
import style0 from "./header-access-espace.vue?vue&type=style&index=0&id=572e0326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e0326",
  null
  
)

export default component.exports